import { FETCH_BIKEMAKEMODALVARIANT_FAILURE, FETCH_BIKEMAKEMODALVARIANT_REQUEST, FETCH_BIKEMAKEMODALVARIANT_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const bikeMakeModalVariant = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BIKEMAKEMODALVARIANT_REQUEST:
            return {
                ...state,
            }
        case FETCH_BIKEMAKEMODALVARIANT_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_BIKEMAKEMODALVARIANT_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}